import { render } from "./LoginPage.vue?vue&type=template&id=844164ee&scoped=true"
const script = {}

import "./LoginPage.vue?vue&type=style&index=0&id=844164ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-844164ee"]])

export default __exports__